import { computed, Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class LoadingService {
	loadingTopics = signal(false);

	loadingContent = signal(false);

	loadingMesssage = signal(false);

	loadingDocument = signal(false);

	loadingDownload = signal(false);

	loading = computed(() => {
		return this.loadingTopics() || this.loadingContent();
	});
}
